import React from 'react'

import artwork from '../../assets/images/home/artwork.svg'

const HomeArwork = () =>{
    return(
        <div className="d">
            <img src={artwork} alt="home artwork" className="artwork"/>
        </div>
    )
}
export default HomeArwork


// WEBPACK FOOTER //
// ./src/components/Pages/HomeArtwork.js